import { render } from "./BrListPage.vue?vue&type=template&id=bc64dd36&scoped=true"
import script from "./BrListPage.vue?vue&type=script&lang=js"
export * from "./BrListPage.vue?vue&type=script&lang=js"

import "./BrListPage.vue?vue&type=style&index=0&id=bc64dd36&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc64dd36"]])

export default __exports__